"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.POSITION_LABEL = exports.POSITION = exports.LIMIT = exports.CHILD = exports.ROOT = void 0;
exports.ROOT = 'vertical-anchor-tab';
exports.CHILD = 'vertical-anchor-tab/vertical-anchor-tab-pane';
exports.LIMIT = {
    MAX: 8
};
exports.POSITION = {
    TOP: 'top',
    MID: 'mid'
};
exports.POSITION_LABEL = {
    [exports.POSITION.TOP]: '点击后滚动至选项顶部',
    [exports.POSITION.MID]: '点击后滚动至选项中间'
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uc3RhbnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJjb25zdGFudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLElBQUksR0FBRyxxQkFBcUIsQ0FBQztBQUM3QixRQUFBLEtBQUssR0FBRyw4Q0FBOEMsQ0FBQztBQUV2RCxRQUFBLEtBQUssR0FBRztJQUNqQixHQUFHLEVBQUUsQ0FBQztDQUNULENBQUM7QUFHVyxRQUFBLFFBQVEsR0FBRztJQUNwQixHQUFHLEVBQUUsS0FBSztJQUNWLEdBQUcsRUFBRSxLQUFLO0NBQ2IsQ0FBQztBQUNXLFFBQUEsY0FBYyxHQUFHO0lBQzFCLENBQUMsZ0JBQVEsQ0FBQyxHQUFHLENBQUMsRUFBRSxZQUFZO0lBQzVCLENBQUMsZ0JBQVEsQ0FBQyxHQUFHLENBQUMsRUFBRSxZQUFZO0NBQy9CLENBQUMifQ==